module.exports = __webpack_public_path__ + "static/img/tree-left.fe839de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/tree-left.svg
// module id = 9svX
// module chunks = 0